import React, { Component } from 'react';

class Privacy extends Component {
    render() {
        return (
            <section className="faq-section pt-115 pb-115" >
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-9 col-xl-8">
                            <div className="border-0 rounded-4 p-4">
                                <div className="mb-4 text-center">
                                    <h1 className="mb-2" style={{ fontWeight: 700, fontSize: "2.5rem" }}>Aviso de Privacidad</h1>
                                    <p className="text-muted mb-0" style={{ fontSize: "1rem" }}>
                                        <span style={{ fontSize: "0.95rem", color: "#ffffff" }}>Última actualización: <strong>17/09/2025</strong></span>
                                    </p>
                                </div>
                                <div className="mb-4">
                                    <p>
                                        En Joyería Bacelis (en adelante, “la Empresa”), respetamos su privacidad y estamos comprometidos a proteger los datos personales de nuestros clientes, usuarios y visitantes de nuestro sitio web{' '}
                                        <a href="https://www.joyeriabacelis.com" target="_blank" rel="noopener noreferrer" style={{ color: "#bfa046", textDecoration: "underline" }}>www.joyeriabacelis.com</a> (en adelante, “el Sitio Web”).
                                    </p>
                                    <p>
                                        Esta Política de Privacidad describe cómo recopilamos, usamos, almacenamos y protegemos su información personal de acuerdo con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP) en México.
                                    </p>
                                </div>
                                <div className="mb-4">
                                    <h4 className="mb-2" style={{ color: "#bfa046", fontWeight: 600 }}>1. Responsable del Tratamiento de Datos Personales</h4>
                                    <ul className="mb-0" style={{ fontSize: "1rem" }}>
                                        <li><strong>Joyería Bacelis</strong></li>
                                        <li><strong>Correo electrónico de contacto:</strong> contacto@joyeriabacelis.com</li>
                                    </ul>
                                </div>
                                <div className="mb-4">
                                    <h4 className="mb-2" style={{ color: "#bfa046", fontWeight: 600 }}>2. Datos Personales que Recopilamos</h4>
                                    <p>Podemos recopilar la siguiente información cuando usted interactúa con nosotros, vía WhatsApp o en alguna de nuestras exposiciones:</p>
                                    <br/>
                                    <ul>
                                        <li>Nombre completo</li>
                                        <li>Número de teléfono</li>
                                    </ul>
                                </div>
                                <div className="mb-4">
                                    <h4 className="mb-2" style={{ color: "#bfa046", fontWeight: 600 }}>3. Finalidades del Tratamiento</h4>
                                    <p>Los datos personales que recabamos serán utilizados para:</p>
                                    <br/>
                                    <ul>
                                        <li>Contactarlo respecto a nuestras fechas de visita a su ciudad.</li>
                                    </ul>
                                    <br/>
                                    <p>
                                        En caso de no desear recibir recordatorios, usted podrá darse de baja en cualquier momento enviando un correo a: contacto@joyeriabacelis.com o vía WhatsApp al número mediante el cual se le contactó.
                                    </p>
                                </div>
                                <div className="mb-4">
                                    <h4 className="mb-2" style={{ color: "#bfa046", fontWeight: 600 }}>4. Transferencia de Datos</h4>
                                    <p>
                                        Joyería Bacelis no vende ni renta los datos personales a terceros. Sin embargo, podemos compartir su información con terceros para los siguientes fines:
                                    </p>
                                    <br/>
                                    <ul>
                                        <li>Enviarle recordatorios sobre nuestras fechas de visita a su ciudad.</li>
                                    </ul>
                                </div>

                                <div className="mb-4">
                                    <h4 className="mb-2" style={{ color: "#bfa046", fontWeight: 600 }}>5. Medidas de Seguridad</h4>
                                    <p>
                                        Implementamos medidas técnicas, administrativas y físicas razonables para proteger su información contra pérdida, robo o acceso no autorizado.
                                    </p>
                                </div>
                                <div className="mb-4">
                                    <h4 className="mb-2" style={{ color: "#bfa046", fontWeight: 600 }}>6. Derechos ARCO (Acceso, Rectificación, Cancelación y Oposición)</h4>
                                    <p>Usted tiene derecho a:</p>
                                    <br/>
                                    <ul>
                                        <li>Acceder a sus datos personales.</li>
                                        <li>Rectificarlos si son inexactos o incompletos.</li>
                                        <li>Cancelarlos cuando lo considere.</li>
                                        <li>Oponerse al uso de los mismos para fines específicos.</li>
                                    </ul>
                                    <br />
                                    <p>
                                        Para ejercer cualquiera de estos derechos, puede enviar una solicitud a:<br />
                                        <strong>Correo electrónico:</strong> contacto@joyeriabacelis.com<br />
                                        <strong>Asunto:</strong> “Solicitud de Derechos ARCO”.
                                    </p>
                                </div>
                                <div className="mb-4">
                                    <h4 className="mb-2" style={{ color: "#bfa046", fontWeight: 600 }}>7. Cambios a esta Política de Privacidad</h4>
                                    <p>
                                        Nos reservamos el derecho de modificar esta Política de Privacidad en cualquier momento. Las actualizaciones serán publicadas en este Sitio Web con la fecha correspondiente.
                                    </p>
                                </div>
                                <div>
                                    <h4 className="mb-2" style={{ color: "#bfa046", fontWeight: 600 }}>8. Aceptación</h4>
                                    <p>
                                        Al utilizar este Sitio Web, usted acepta los términos de esta Política de Privacidad.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Privacy;
